import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchBookBySlug } from "../lib/booksApi";
import BookLandingView from "./BookLandingView";

export default function BookLandingPage() {
  const { slug } = useParams();
  const [state, setState] = useState({ status: "loading", book: null });

  useEffect(() => {
    setState({ status: "loading", book: null });
    fetchBookBySlug(slug).then(({ data }) => {
      setState({ status: data ? "ready" : "not-found", book: data });
    });
  }, [slug]);

  useEffect(() => {
    if (state.book) {
      document.title = state.book.title;
    }
  }, [state.book]);

  if (state.status === "loading") return null;
  if (state.status === "not-found") {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-zinc-600">Book not found.</p>
      </div>
    );
  }

  return <BookLandingView book={state.book} />;
}
